import React, { useState, useEffect } from "react";
import { InputBase, Button } from "@mui/material";
import { Stack } from "@mui/material";
import { Box } from "@mui/material";
import TextField from "@mui/material/TextField";

function FileSelectionComponent({ handleFile, error }) {
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {}, [error]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);

        handleFile(file);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Stack spacing={2} direction={"row"} sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                    <TextField
                        id="outlined-basic"
                        label="Image file"
                        variant="outlined"
                        value={selectedFile ? selectedFile.name : ""}
                        InputProps={{
                            readOnly: true,
                        }}
                        error={error}
                        fullWidth
                        size="small"
                    />
                </Box>

                <label htmlFor="file-input">
                    <InputBase id="file-input" type="file" onChange={handleFileChange} style={{ display: "none" }} />
                    <Button variant="contained" component="span" sx={{ backgroundColor: "#34935A", "&:hover": { backgroundColor: "#4DAC71" } }}>
                        Select File
                    </Button>
                </label>

                {/* <Box sx={{ display: "flex", alignItems: "center" }}>{selectedFile && <p>Selected file: {selectedFile.name}</p>}</Box> */}
            </Stack>
        </Box>
    );
}

export default FileSelectionComponent;
